import {DecimalPipe} from '@angular/common';

export function getTimeFrame(clock: string): any {
  if (clock === '1m') {
    return { name: '1m', seconds: 60 };
  } else {
    return { name: '5m', seconds: 300 };
  }
}

export function getProfitClass(value: number, digitsInfo: string): string {
  const decimalPipe = new DecimalPipe('en-US');

  const result = +decimalPipe.transform(value, digitsInfo);

  if (result > 0) {
    return 'text-green';
  } else if (result < 0) {
    return 'text-red';
  } else {
    return 'text-yellow';
  }
}

export function join<T, RT>(
  roots: T[],
  refers: RT[],
  key,
  foreinKey,
  prop
): any {
  if (roots.length && refers.length) {
    roots.forEach((element) => {
      element[prop] = refers.filter((x) => x[key] === element[foreinKey])[0];
    });
  }
  return roots;
}

export async function asyncForEach(array, callback): Promise<any> {
  for (let i = 0; i < array.length; i++) {
    await callback(array[i], i, array);
  }
}

export function clone(obj: any): any {
  return JSON.parse(JSON.stringify(obj));
  // return {...obj, cloneKey: new Date().getTime()};
}

export function standardizeParam(jsonParam): string {
  let output = '';
  for (const key of Object.keys(jsonParam)) {
    if (jsonParam[key] !== null && jsonParam[key] !== undefined) {
      output += key + '=' + jsonParam[key] + '&';
    }
  }
  if (output.length > 0) {
    return output.substr(0, output.length - 1);
  }
  return '';
}

export function calculateTime(d1: any, d2: any, type: string = 'd'): number {
  let from = 0;
  let to = 0;
  if (typeof d1 === 'string') {
    from = new Date(d1).getTime();
  } else if (d1 instanceof Date) {
    from = d1.getTime();
  } else {
    from = d1;
  }
  if (typeof d2 === 'string') {
    to = new Date(d2).getTime();
  } else if (d2 instanceof Date) {
    to = d2.getTime();
  } else {
    to = d2;
  }
  const diffTime = Math.abs(to - from);
  let result = 0;
  switch (type) {
    case 'd':
      result = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      break;
    case 'h':
      result = Math.ceil(diffTime / (1000 * 60 * 60));
      break;
    case 'm':
      result = Math.ceil(diffTime / (1000 * 60));
      break;
    default:
      result = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      break;
  }
  return result;
}

export function getFlooredFixed(v: number, d: number): string {
  return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
}

export function getTime(seconds: number, format = 'mm:ss'): string {
  let mins: any = Math.floor(seconds / 60);
  const secs: any = seconds - mins * 60;
  let m = mins < 10 ? '0' + mins : mins;
  const s = secs < 10 ? '0' + secs : secs;
  if (format !== 'hh:mm:ss') {
    return `${m}:${s}`;
  }
  const hours = Math.floor(mins / 60);
  mins = mins - hours * 60;
  const h = hours < 10 ? '0' + hours : hours;
  m = mins < 10 ? '0' + mins : mins;
  return `${h}:${m}:${s}`;
}

export function capitalizeFirstLetter(str: string): any {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getMonths(months: any, index: number = 12, rev?: boolean): string[] {
  const d = new Date();
  let currentMonth = d.getMonth();
  const ms = [`${months[currentMonth]} ${d.getFullYear()}`];
  for (let i = 1; i < index; i++) {
    const date = new Date(d.setMonth(currentMonth - 1));
    currentMonth = date.getMonth();
    ms.push(`${months[currentMonth]} ${d.getFullYear()}`);
  }
  return rev ? ms.reverse() : ms;
}

export function getDates(index: number = 30, rev?: boolean): number[] {
  const d = new Date();
  let currentDate = d.getDate();
  const ms = [currentDate];
  for (let i = 1; i < index; i++) {
    const date = new Date(d.setDate(currentDate - 1));
    currentDate = date.getDate();
    ms.push(currentDate);
  }
  return rev ? ms.reverse() : ms;
}

export function getTimeRemoveTimezoneOffset(time){
  return new Date(new Date(time).getTime() - new Date().getTimezoneOffset()* 60000).getTime()
}

export function date2String(date: Date, separate: string = '-'): string {
  const d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const m =
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  return `${date.getFullYear()}${separate}${m}${separate}${d}`;
}


export function getAccountNameByType(data): any {
  if(data.isMam){
    return 'Mam';
  }
  switch (data.accountType) {
    case 0: {
      return 'Standard';
    }
    case 1: {
      return 'Micro';
    }
    case 2: {
      return 'Pro';
    }
    case 3: {
      return 'STD-RB';
    }
    case 4: {
      return 'MIC-RB';
    }
    case 5: {
      return 'Pro-RB';
    }
    default: {
      return 'Standard';
    }
  }
}

export function getTimeDateBegin(date: Date): number {
  const dateValue = new Date(date);
  dateValue.setUTCHours(0,0,0,0);
  return dateValue.getTime();
}

export function getTimeDateEnd(date: Date): number {
  const dateValue = new Date(date);
  dateValue.setUTCHours(23,59,59,999);
  return dateValue.getTime();
}
